import { Stack, styled } from "@mui/material";
import {
  TESTIMONIALS_LOGO_1,
  TESTIMONIALS_LOGO_10,
  TESTIMONIALS_LOGO_11,
  TESTIMONIALS_LOGO_2,
  TESTIMONIALS_LOGO_3,
  TESTIMONIALS_LOGO_4,
  TESTIMONIALS_LOGO_5,
  TESTIMONIALS_LOGO_6,
  TESTIMONIALS_LOGO_7,
  TESTIMONIALS_LOGO_8,
  TESTIMONIALS_LOGO_9,
  TESTIMONIALS_LOGO_16,
  TESTIMONIALS_LOGO_17,
  TESTIMONIALS_LOGO_18,
  TESTIMONIALS_LOGO_19,
  TESTIMONIALS_LOGO_20,
  TESTIMONIALS_LOGO_21,
  TESTIMONIALS_LOGO_22,
  TESTIMONIALS_LOGO_23,
  TESTIMONIALS_LOGO_24,
} from "Assets/images";
import {
  CountryFlag,
  Img,
  LgTextSemiBold,
  SmText,
  StyledATag,
  Swiper,
  TextMd,
} from "Components";
import { ALink } from "Components/link";
import { AUTO_PLAY_ITEM_TIME, COLORS } from "constants/layout";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { SwiperSlide } from "swiper/react";

type Props = {
  title?: string;
};

const BREAKPOINTS = {
  300: {
    slidesPerView: 2,
    spaceBetween: 8,
  },
  640: {
    slidesPerView: 4,
    spaceBetween: 8,
  },
  1048: {
    slidesPerView: 5,
    spaceBetween: 8,
  },
};

type TestimonialType = {
  logo: string;
  name: string;
  country: { company_country?: string; country_code?: string };
  desc: string;
  link: string;
};

const Testimonials = ({ title = "testimonials" }: Props) => {
  const t = useIntl();

  const testimonials: TestimonialType[] = useMemo(
    () => [
      {
        logo: TESTIMONIALS_LOGO_16,
        name: "Pongsamutthara",
        country: { company_country: "Thailand", country_code: "th" },
        desc: "testimonials_note_16",
        link: "https://freshdi.com/supplier/pongsamutra",
      },
      {
        logo: TESTIMONIALS_LOGO_17,
        name: "SuMa Wasserbetten GmbH",
        country: { company_country: "Germany", country_code: "de" },
        desc: "testimonials_note_17",
        link: "https://freshdi.com/supplier/SuMa-Wasserbetten-GmbH",
      },
      {
        logo: TESTIMONIALS_LOGO_18,
        name: "Weihai Yueting Trading Co., Ltd",
        country: { company_country: "China", country_code: "cn" },
        desc: "testimonials_note_18",
        link: "https://freshdi.com/supplier/Weihai-Yueting-Trading-Co-Ltd",
      },
      {
        logo: TESTIMONIALS_LOGO_19,
        name: "Selekta International",
        country: { company_country: "Tunisia", country_code: "tn" },
        desc: "testimonials_note_19",
        link: "https://freshdi.com/supplier/Selekta-International",
      },
      {
        logo: TESTIMONIALS_LOGO_20,
        name: "Dovi Food Co., Ltd",
        country: { company_country: "Vietnam", country_code: "vn" },
        desc: "testimonials_note_20",
        link: "https://freshdi.com/supplier/Dovi-Food-Co-Ltd",
      },
      {
        logo: TESTIMONIALS_LOGO_21,
        name: "Dalian Handom Chemils Co., Ltd.",
        country: { company_country: "China", country_code: "cn" },
        desc: "testimonials_note_21",
        link: "https://freshdi.com/supplier/Dalian-Handom-Chemicals-Co-Ltd-",
      },
      {
        logo: TESTIMONIALS_LOGO_22,
        name: "PT Pratama Ekspor Bersama",
        country: { company_country: "Indonesia", country_code: "id" },
        desc: "testimonials_note_22",
        link: "https://freshdi.com/supplier/PT-Pratama-Ekspor-Bersama",
      },
      {
        logo: TESTIMONIALS_LOGO_23,
        name: "DNONNYS CHEMCO LTD",
        country: { company_country: "Nigeria", country_code: "ng" },
        desc: "testimonials_note_23",
        link: "https://freshdi.com/supplier/DNONNYS-CHEMCO-LTD",
      },
      {
        logo: TESTIMONIALS_LOGO_24,
        name: "MUNAEVA RADZHANA LEONIDOVNA (IP)",
        country: { company_country: "Russian Federation", country_code: "ru" },
        desc: "testimonials_note_24",
        link: "https://freshdi.com/supplier/SP-RM",
      },
      {
        logo: TESTIMONIALS_LOGO_1,
        name: "Les Artisans du Monde",
        country: { company_country: "Canada", country_code: "ca" },
        desc: "testimonials_note_1",
        link: "https://freshdi.com/supplier/Les-Artisans-du-Monde",
      },
      {
        logo: TESTIMONIALS_LOGO_2,
        name: "Bruckmann GmbH",
        country: { company_country: "Germany", country_code: "de" },
        desc: "testimonials_note_2",
        link: "https://freshdi.com/supplier/Bruckmann-GmbH",
      },

      {
        logo: TESTIMONIALS_LOGO_3,
        name: "Interfresh Food and Beverage Company Limited",
        country: { company_country: "Vietnam", country_code: "vn" },
        desc: "testimonials_note_3",
        link: "https://freshdi.com/supplier/INTERFRESH-FOOD-AND-BEVERAGE-COMPANY-LIMITED",
      },
      {
        logo: TESTIMONIALS_LOGO_4,
        name: "Garden to global exports pvt ltd",
        country: { company_country: "Pakistan", country_code: "pk" },
        desc: "testimonials_note_4",
        link: "https://freshdi.com/supplier/Garden-to-global-exports-pvt-ltd",
      },
      {
        logo: TESTIMONIALS_LOGO_5,
        name: "VERTEKS MVE NIG LTD",
        country: { company_country: "Nigeria", country_code: "ng" },
        desc: "testimonials_note_5",
        link: "https://freshdi.com/supplier/VERTEKS-MVE-NIG-LTD",
      },
      {
        logo: TESTIMONIALS_LOGO_6,
        name: "Guangdong Meteor Century International Trade CoActiv",
        country: { company_country: "China", country_code: "cn" },
        desc: "testimonials_note_6",
        link: "https://freshdi.com/supplier/yates%C2%B7ye",
      },
      {
        logo: TESTIMONIALS_LOGO_7,
        name: "PT Najah Triumph Optima",
        country: { company_country: "Indonesia", country_code: "id" },
        desc: "testimonials_note_7",
        link: "https://freshdi.com/supplier/PT-Najah-Triumph-Optima",
      },
      {
        logo: TESTIMONIALS_LOGO_8,
        name: "Akpobi and sons enterprise",
        country: { company_country: "Nigeria", country_code: "ng" },
        desc: "testimonials_note_8",
        link: "https://freshdi.com/supplier/Akpobi-and-sons-enterprise",
      },
      {
        logo: TESTIMONIALS_LOGO_9,
        name: "Favdip Global Resources Ltd",
        country: { company_country: "Nigeria", country_code: "ng" },
        desc: "testimonials_note_9",
        link: "https://freshdi.com/supplier/Favdip-Global-Resources-Ltd",
      },

      {
        logo: TESTIMONIALS_LOGO_10,
        name: "Công ty TNHH Chế Biến Nông Hải Sản Biển Xanh",
        country: { company_country: "Vietnam", country_code: "vn" },
        desc: "testimonials_note_10",
        link: "https://freshdi.com/supplier/Cong-ty-co-phan-Gao-Lotus",
      },
      {
        logo: TESTIMONIALS_LOGO_11,
        name: "Chukwubiko and sons global Limited ",
        country: { company_country: "Nigeria", country_code: "ng" },
        desc: "testimonials_note_11",
        link: "https://freshdi.com/supplier/Chukwubiko-and-sons-global-Limited",
      },
    ],
    []
  );

  return (
    <StyledTestimonials spacing={1} className="testimonials">
      <LgTextSemiBold className="title">
        {t.formatMessage({ id: title })}
      </LgTextSemiBold>

      <Swiper
        pagination={undefined}
        autoplay={{ delay: AUTO_PLAY_ITEM_TIME, disableOnInteraction: false }}
        breakpoints={BREAKPOINTS}
      >
        {testimonials.map((testimonial: TestimonialType, i: number) => {
          const country = testimonial.country;
          return (
            <SwiperSlide key={i}>
              <StyledATag href={testimonial.link}>
                <Stack spacing={{ xs: 1.5, md: 2 }} className="testimonial">
                  <Img src={testimonial.logo} alt="img" className="logo" />
                  <Stack spacing={1}>
                    <ALink className="name-link">
                      <TextMd
                        color="var(--green-700)"
                        className="name ellipsis-text"
                      >
                        {testimonial.name}
                      </TextMd>
                    </ALink>

                    <div>
                      <CountryFlag
                        fd_country={country.company_country}
                        country_code={country.country_code}
                      />
                    </div>
                    <SmText
                      align="center"
                      className="cutoff-text threeline desc-text text"
                    >
                      "{t.formatMessage({ id: testimonial.desc })}"
                    </SmText>
                  </Stack>
                </Stack>
              </StyledATag>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </StyledTestimonials>
  );
};

const StyledTestimonials = styled(Stack)(({ theme }) => ({
  ".testimonial": {
    borderRadius: 32,
    textAlign: "center",
    backgroundColor: "#fff",
    border: `1px solid ${COLORS.gray[200]}`,
    padding: "24px 16px",
    height: 275,
    ".name-link": {
      textDecorationColor: "var(--green-700)",
    },
    ".logo": {
      width: 100,
      height: 100,
      objectFit: "cover",
      borderRadius: "50%",
      margin: "0 auto",
    },
    ".country_flag": {
      margin: "0 auto",
      border: "none",
      fontSize: 14,
      backgroundColor: "initial",
      img: {
        height: 12,
      },
    },
  },
  [theme.breakpoints.down("md")]: {
    ".testimonial": {
      padding: "18px 16px",
      height: 250,
      ".logo": {
        width: 80,
        height: 80,
      },
      ".name": {
        fontSize: 14,
      },
      ".country_flag": {
        fontSize: 12,
      },
      ".desc-text": {
        fontSize: 12,
      },
    },
  },
}));

export default Testimonials;
